export enum EAnalyticDataType {
  DATE = 'DATE',
  ARRAY = 'ARRAY',
  OBJECT = 'OBJECT',
  STRING = 'STRING',
  INTEGER = 'INTEGER',
  CURRENCY = 'CURRENCY',
  PERCENT = 'PERCENT',
  DURATION = 'DURATION',
  MONTH = 'MONTH_TIMESTAMP',
  QUARTER = 'QUARTER_TIMESTAMP',
  DAY = 'DAY_TIMESTAMP',
  WEEK = 'WEEK_TIMESTAMP',
  YEAR = 'YEAR_TIMESTAMP',
  HOUR = 'HOUR_TIMESTAMP',
}

export enum EAnalyticColumnKey {
  CAMPAIGNS = 'experiments',
  VISITOR_ITEMS = 'visitor_items',
  DEVICE_ITEMS = 'device_items',
  TRAFFIC_SOURCE_ITEMS = 'traffic_source_items',
}

export type AnalyticPrimitiveValueType = string | number | null;
export type AnalyticValueType = AnalyticPrimitiveValueType;
